/**
 * select要素のsubmit処理
 */

export default class FilterSubmit {
  constructor(selector) {
    this.selector = selector;
    this.el = document.querySelector(selector);

    if (!this.el) return;

    this.submitEl = this.el.querySelector('button[type="submit"]');
    this.resetBtnEl = this.el.querySelector('button[type="reset"]');
    // プレスリリース: 公開年, 特集記事: シリーズ select要素
    this.selectEls = this.el.querySelectorAll('select');
    // プレスリリース, 特集記事: カテゴリ label要素
    this.categoryEls = this.el.querySelectorAll('.c-category');
    // プレスリリース: フリーワード検索 input
    this.freeWordEls = this.el.querySelector('.c-input__input');

    this.handleUpdateSelected = this.handleUpdateSelected.bind(this);
    this.handleReset = this.handleReset.bind(this);

    this.initialize();
  }

  initialize() {
    // ボタンがない場合は select の変更で submit(IRニュースのみ)
    if (!this.submitEl) {
      this.selectEls.forEach((select) => {
        select.addEventListener('change', this.handleUpdateSelected);
      });
    }
    if (this.resetBtnEl) {
      this.resetBtnEl.addEventListener('click', this.handleReset);
    }
  }

  handleUpdateSelected() {
    this.el.submit();
  }

  // リセットボタンが押されたら、全ての要素を初期値に戻す
  handleReset(e) {
    e.preventDefault();

    // 各 select 要素の選択状態を初期状態にする
    if (this.selectEls) {
      this.selectEls.forEach((select) => {
        select.selectedIndex = 0;
      });
    }

    // 各 checkbox 要素をチェック解除する
    if (this.categoryEls) {
      this.categoryEls.forEach((category) => {
        const checkbox = category.querySelector('.c-category__input');
        if (checkbox) {
          checkbox.checked = false;
        }
      });
    }

    // フリーワード入力フィールドを空にする
    if (this.freeWordEls) {
      this.freeWordEls.value = '';
    }
  }
}
